export const PLAN_STATUS = {
  CHOOSE_GUIDE: "choose-guide",
  INVITE_STUDENT: "invite-student",
  SIT_WITH_STUDENT: "sit-with-student",
  INVITE_MENTORS: "invite-mentors",
  SEND_PLAN: "send-plan",
  CHECKLIST_COMPLETE: "checklist-complete",
  PLAN_COMPLETE: "plan-complete",
}